import { Countries } from '@xoda/common'
import { useCallback, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { gymState } from '../store/gym'

const useCurrency = () => {
  const gym = useRecoilValue(gymState)

  const formatAmount = useCallback(
    (value: unknown, short = false) => {
      return Countries.formatAmount(value, gym?.currency_code, short)
    },
    [gym?.currency_code]
  )

  return useMemo(
    () => ({
      formatAmount,
    }),
    [formatAmount]
  )
}

export { useCurrency }
